import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { type ClassificationConceptData } from '../types'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

/**
 * ConceptListChart function renders a bar chart using the returned data from the API.
 * @param {any} {data}:ChartProps
 * @returns {any}
 */
interface ChartProps {
  data: ClassificationConceptData[]
}

function ConceptListChart ({ data }: ChartProps): JSX.Element {
  // collor pallet for the bar chart.
  const barColors = ['#add8c7', '#ff0066', '#556270', '#cdd7b6']

  const barData = {
    labels: data.map(data => data.display_name),
    datasets: [{
      backgroundColor: barColors,
      data: data.map(data => data.score),
      barPercentage: 0.5,
      categoryPercentage: 0.5
    }]
  }

  const barOptions = {
    plugins: {
      legend: {
        display: false
      }
    }
  }

  return (
    <div className="col-md-12 col-sm-12 col-lg-5 order-md-last lr-bar-canvas">
      <Bar options={barOptions} data={barData} />
    </div>)
}

export default ConceptListChart
